import React, {Component} from 'react';

import UpgradePersonalAccountForm from './UpgradePersonalAccountForm';

class UpgradePersonalAccount extends Component {

	componentDidMount() {
		//after REACT updates DOM, call bootstrap to scan for tooltips *again* to apply event listeners to them.
		const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
		popoverTriggerList.forEach(function (popoverTriggerEl) {
			new window.bootstrap.Popover(popoverTriggerEl);
		});
	}

	constructor(props) {
		super(props);
		this.state = {
			orgType: "FIRST_NET"

		}
	}

	render()	{
		return(
		<div className="container-fluid">
          <div className="row padTop padBottom">
              <div className="col-12 col-6">
                  <div className="card">
                    <div className="card-header">
                    	<h1><i className="fa fa-cloud-upload-alt"/> Upgrade Individual Account </h1>
                    </div>
                   	<UpgradePersonalAccountForm />
                  </div>
               </div>
  			</div>
  		 </div>
		)
	}
}

export default UpgradePersonalAccount;


// WEBPACK FOOTER //
// ./src/manageMyAccount/UpgradePersonalAccount.js